



































































import {Component, Vue, Emit, Watch} from 'vue-property-decorator';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTagBox from 'devextreme-vue/tag-box';
import DButton from '@/components/DButton/button.vue';

import YearService from '@/services/years-service';
import CutService from '@/services/cut-service';
import _, { result } from 'lodash';
import AuthService from "@/services/auth_service";
import ImbalanceService from '@/services/imbalance_service';

@Component({
  name: 'InputControlHeader',
  components: {
    DxSelectBox,
    DxCheckBox,
    DxTagBox,
    DButton
  }
})
export default class  extends Vue {

  public cutService = CutService;
  public auth_service = AuthService;
  public year_ds = YearService.filteredYearList;
  public cut_ds: any[] = [];

  public id_year: string | null = null;
  public id_cut: string | null = null;
  public saved_filters: any = {
    year_id: null,
    cut_id: null,
  }
  public ls_key: string = 'input_blocks_control_filter';


  get relative_cut() {
    let list = [];
    if (this.id_year) {
      list = this.cut_ds.filter((c:any) => c.id_year === this.id_year && (c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех'));
    }
    return list;
  }

  get yearName() {
    let result = 0;
    if (this.id_year) {
      const year = this.year_ds.find((y:any) => y.id === this.id_year);
      if(year) result = year.name;
    }
    return result
  }

  async created() {
    this.loadFilters();

    const res = await this.cutService.get();
    if (res.data) {
      const sorted = _.sortBy(res.data, [(o) => o.number]);
      this.cut_ds = sorted;
    }
  }

  @Watch("id_year")
  async changeYear() {
    this.saveFilters();
  }
  @Watch("id_cut")
  async changeCut() {
    this.saveFilters();
  }

  @Emit('onLoad')
  onLoad() {
    ImbalanceService.getImbalanceColors()
    const result = {cut: this.id_cut, year: this.yearName}
    return result
  }

  saveFilters() {
    this.saved_filters.year_id = this.id_year;
    this.saved_filters.cut_id = this.id_cut;

    localStorage.setItem(`${this.auth_service.getUserId()}_${this.ls_key}`, JSON.stringify(this.saved_filters));
  }


  loadFilters() {
    const saved = localStorage.getItem(`${this.auth_service.getUserId()}_${this.ls_key}`);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        this.saved_filters = _.clone(parsed);

        this.id_year = this.saved_filters.year_id
        this.id_cut = this.saved_filters.cut_id
      } catch (e) {
        //
      }
    }
  }
}
